<template>
  <div class="big">
    <div class="page_title">问诊记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-menu :default-active="activeIndex"
                   class="el-menu-demo"
                   mode="horizontal"
                   @select="handleSelect">
            <el-menu-item index="2"
                          style="font-size: 16px">进行中</el-menu-item>
            <el-menu-item index="1"
                          style="font-size: 16px">已结束</el-menu-item>
            <el-menu-item index="3"
                          style="font-size: 16px">退款记录</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WenzhenIng from './WenzhenIng.vue';
import WenzhenOver from './WenzhenOver.vue';
import RefundRecord from './RefundRecord.vue';

export default {
  data() {
    return {
      activeIndex: '2',
      active: '2'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return WenzhenOver;
        case '2':
          return WenzhenIng;
        case '3':
          return RefundRecord;
        default:
          return WenzhenOver;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
